<template>
  <div class="custom-table">
    <div class="custom-table-buttons">
      <b-button
          class="btn-sm btn-nav-link btn-nav-link-white"
          size="sm"
          variant="flat-primary"
          v-if="hasUpdateDataButton"
          @click="updateData"
      >
        <feather-icon icon="RefreshCwIcon" /> 
        {{ $t('TABLE.UpdateData') }}
      </b-button>
      <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        size="sm"
        variant="flat-primary"
        v-if="hasExportDataButton"
        @click="exportData"
      >
        <feather-icon icon="FileTextIcon" />
        {{ $t('TABLE.Export') }}
      </b-button>
      <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        size="sm"
        variant="flat-primary"
        v-if="hasAdvancedFilterButton"
        @click="openAdvancedFilter"
      >
        <feather-icon icon="SearchIcon" />
        {{ $t('TABLE.Filters') }}
      </b-button>

    </div>

    <hr v-if="displayAdvancedFilters">
    <b-row v-if="displayAdvancedFilters">
      <b-col v-for="(item, index) in advancedFilters" :key="index" :md="item.size ? item.size : 3">
        <b-form-group v-if="item.type == 'input'">
          <label :for="item.field">{{item.label}}</label>
          <b-form-input :id="item.field" v-model="item.value" @keyup.enter="fetchAdvancedFilter"/>
        </b-form-group>
        <b-form-group v-if="item.type == 'dropdown'">
          <label :for="item.field">{{item.label}}</label>
          <v-select v-model="item.value" label="name"
            :options="item.filterDropdownItems" :placeholder="item.label" :reduce="option => option.value" @input="fetchAdvancedFilter" :multiple="item.multiple">
            <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
          </v-select>
        </b-form-group>

        <b-form-group v-if="item.type == 'date'">
          <label :for="item.field">{{item.label}}</label>
          <flat-pickr v-model="item.value"
            @on-change="fetchAdvancedFilter"
            :placeholder="item.label" :config="{
              enableTime: false,
              dateFormat: 'Y-m-d',
              altInput: true,
              altFormat: 'd/m/Y',
              allowInput: true,
            }" />
        </b-form-group>
        <b-form-group v-if="item.type == 'dateRange'">
          <label :for="item.field">{{item.label}}</label>
          <flat-pickr v-model="item.value"
            :placeholder="item.label" :config="{
              enableTime: false,
              dateFormat: 'Y-m-d',
              altInput: true,
              altFormat: 'd/m/Y',
              allowInput: true,
              mode: 'range',
            }" />
        </b-form-group>
      </b-col>
      <!-- style="text-align: right;" -->
      <b-col md="12">
        <b-button
          class="btn-sm btn-nav-link btn-nav-link-white"
          size="sm"
          variant="flat-primary"
          @click="fetchAdvancedFilter"
        >
          <feather-icon icon="SearchIcon" />
          {{ $t('TABLE.Search') }}
        </b-button>
        <b-button
          class="btn-sm btn-nav-link btn-nav-link-white btn-filter-clear"
          size="sm"
          variant="flat-primary"
          @click="clearAdvancedFilter"
        >
          <feather-icon icon="TrashIcon" />
          {{ $t('TABLE.Clear') }}
        </b-button>
      </b-col>
    </b-row>
    <hr v-if="displayAdvancedFilters">

    <div>
      <span class="table-total-result" v-if="totalRows >= 1">{{totalRows}} {{ $t('TABLE.TotalResults') }}</span>
    </div>
    
      <!-- :suppressScrollY="true" -->
      <!-- :suppressScrollX="true" -->
      <!-- :isLoading.sync="isLoading" -->
      <vue-good-table
        mode="remote"
        :columns="tableColumns"
        :rows="items"
        :rtl="false"
        :search-options="{
          enabled: true,
          trigger: 'enter',
          externalQuery: searchTerm }"
        :select-options="{
          enabled: false,
          selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        :max-height="tableMaxHeight"
        class="vue-g-table"
      >
        <!-- :fixed-header="true" -->
        <!-- @on-row-click="$refs.menu.open" -->
        
        <!-- Slot: Table Row -->
        <template slot="table-row" slot-scope="props">
          <!-- <span @contextmenu.prevent="$refs.menu.open"> -->
          <span>
            <span v-if="props.column.type === 'avatar'">
              <b-avatar :src="props.row[props.column.field]" />
            </span>

            <span v-else-if="props.column.type === 'phone'">
              {{ getPhoneFormat(props.row[props.column.field]) }}
            </span>
            <span v-else-if="props.column.type === 'boolean' && props.column.field === 'isDesktop'">
              {{ props.row.isDesktop ? $t('TABLE.Desktop') : $t('TABLE.Mobile') }}
            </span>
            <span v-else-if="props.column.type === 'boolean' && props.column.field === 'hasError'">
              <b-badge variant="light-danger" v-if="props.row[props.column.field]">{{ $t('BOOLEAN.Yes') }}</b-badge>
            </span>
            <span v-else-if="props.column.type === 'boolean'">
              <b-badge
                :variant="getActiveBadge(props.row[props.column.field])"
              >
                {{ getActiveBadgeLabel(props.row[props.column.field]) }}
              </b-badge>
            </span>
            <span v-else-if="props.column.type === 'custom_date'">
              {{ getDateFormat(props.row[props.column.field]) }}
            </span>
            <span v-else-if="props.column.type === 'thumb'">
              <img :src="props.row[props.column.field]" />
            </span>

            <span v-else-if="props.column.type === 'object'">
              {{ getDataObject(props.row[props.column.field], props.column.object_field, props.column.object_field_type, props.column.object_in_object_field) }}
            </span>

            <span v-else-if="props.column.type === 'array'" >
              <span>{{ getDataArray(props.row[props.column.field], props.column.object_field, props.column.object_field_type, props.column.object_in_object_field) }}</span>
              <!-- <span
                v-for="(val, index) in props.row[props.column.field]"
                :key="index"
              >
                {{ getDataObject(val, props.column.object_field, props.column.object_field_type) }},
              </span> -->
            </span>

            <!-- Column: Action -->
            <!-- <span v-else-if="props.column.field === 'asdasdasdasd'"> -->
            <span v-else-if="props.column.field === 'action_buttons'">
              <span>
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item @click="onEdit(props.row)" v-if="hasEditButton">
                    <feather-icon icon="Edit2Icon" class="mr-50" />
                    <span>{{ $t('TABLE.Edit') }}</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="onDelete(props.row)" v-if="hasDeleteButton">
                    <feather-icon icon="TrashIcon" class="mr-50" />
                    <span>{{ $t('TABLE.Delete') }}</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="onSync(props.row)" v-if="hasSyncButton">
                    <feather-icon icon="RefreshCwIcon" class="mr-50" />
                    <span>{{ $t('TABLE.Sync') }}</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="onResend(props.row)" v-if="hasResendButton">
                    <feather-icon icon="SendIcon" class="mr-50" />
                    <span>{{ $t('TABLE.Resend') }}</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="openTemplate(props.row)" v-if="hasOpenTemplateButton">
                    <feather-icon icon="Maximize2Icon" class="mr-50" />
                    <span>{{ $t('TABLE.OpenTemplate') }}</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="openAnswer(props.row)" v-if="hasAnswer">
                    <feather-icon icon="MessageSquareIcon" class="mr-50" />
                    <span>{{ $t('TABLE.Answer') }}</span>
                  </b-dropdown-item>
                </b-dropdown>
              </span>
            </span>
            <!-- <span v-else-if="props.column.type == 'limitText'">
              {{ getTextLimit(props.row[props.column.limitText], props.row[props.column.field]) }}
            </span> -->
            <!-- Column: Common -->
            <span v-else >
              {{ props.formattedRow[props.column.field] }}
            </span>

          </span>

          
            <!-- <vue-context ref="menu">
            <li>
              <b-link @click="onEdit(props.row)" v-if="hasEditButton">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>{{ $t('TABLE.Edit') }}</span>
              </b-link>
              <b-link @click="onDelete(props.row)" v-if="hasDeleteButton">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>{{ $t('TABLE.Delete') }}</span>
              </b-link>
            </li>
          </vue-context> -->

        </template>

        <!-- Filtro das colunas de data: datepicker no lugar do texto livre (texto que não é data gerava erro 500).
             Nas demais colunas o slot não renderiza nada e o vue-good-table usa o filtro padrão -->
        <template slot="column-filter" slot-scope="props">
          <div v-if="isDateFilterColumn(props.column)" class="column-filter-date">
            <flat-pickr
              :value="getDateFilterValue(props.column)"
              class="vgt-input"
              :placeholder="props.column.filterOptions.placeholder"
              :config="columnFilterDateConfig"
              @on-change="(selectedDates, dateStr) => onDateColumnFilter(props, dateStr)"
            />
            <feather-icon
              v-if="getDateFilterValue(props.column)"
              icon="XIcon"
              class="column-filter-date-clear cursor-pointer"
              @click="onDateColumnFilter(props, '')"
            />
          </div>
          <!-- Filtro numerico (filterOptions.numeric, ex.: Codigo): so aceita digitos; letra gerava erro 500 -->
          <div v-else-if="isNumericFilterColumn(props.column)" class="column-filter-numeric">
            <input
              type="text"
              inputmode="numeric"
              class="vgt-input"
              :placeholder="props.column.filterOptions.placeholder"
              :value="getNumericFilterValue(props.column)"
              @input="onNumericColumnFilter(props, $event)"
              @keyup.enter="onNumericColumnFilter(props, $event, true)"
            />
            <small v-if="numericFilterWarnings[props.column.field]" class="column-filter-numeric-warning">
              {{ $t('TABLE.Only_Numbers') }}
            </small>
          </div>
        </template>

        <div slot="emptystate">
          {{ $t('TABLE.NoResults') }}
        </div>
      </vue-good-table>

          <!-- <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scroll-custom-table"
      :useBothWheelAxes="true"
    >
      </vue-perfect-scrollbar> -->

      <!-- pagination -->
      <!-- <b-card-body class="d-flex justify-content-between flex-wrap pt-2"> -->
      <b-card-body class="d-flex pt-2">
        <!-- <b-col md="4"></b-col> -->
        
        <!-- page length -->
        <b-col v-if="hasPerPageSelect" class="per-page-table" :class="{'per-page-custom': hasPerPageSelect}">
          <b-form-group
            label="Registro por página"
            label-cols="5"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
          >
            <b-form-select
              id="perPageSelect"
              v-model="limit"
              size="sm"
              inline
              :options="pageOptions"
            />
          </b-form-group>
        </b-col>
        
        <b-col class="pagination-table" :class="{'pagination-custom': hasPerPageSelect}">
          <!-- pagination -->
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="limit"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
            @change="handleChangePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
        <!-- <span>Exibindo {{limit}} de {{totalRows}} registros</span> -->
        <!-- <span v-if="totalRows > 1">{{totalRows}} {{ $t('TABLE.TotalResults') }}</span> -->
      </b-card-body>
  </div>
</template>

<script>
import {
  BCardBody,
  BDropdown,
  BDropdownItem,
  //   BFormCheckbox,
  BButton,
  BCard,
  BRow,
  BCol,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormSelect,
  BFormInput
  // BLink
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { VueGoodTable } from "vue-good-table";
import AppConstants from "@/appConstants";
// import convertDatetimeHelper from "@/helpers/convert-datetime-helper";
import { formatDate } from "@core/utils/filter";
import translateFieldHelper from '@/helpers/translate-field-helper';
import formatFieldHelper from '@/helpers/format-field-helper';
import messageDialogHelper from '@/helpers/message-dialog-helper';
// import VuePerfectScrollbar from "vue-perfect-scrollbar";
// import VueContext from 'vue-context';

export default {
  components: {
    // VueContext,
    // BLink,
    // VuePerfectScrollbar,
    BCardBody,
    BDropdown,
    BDropdownItem,
    VueGoodTable,
    // BFormCheckbox,
    // eslint-disable-next-line vue/no-unused-components
    BButton,
    // eslint-disable-next-line vue/no-unused-components
    BCard,
    // eslint-disable-next-line vue/no-unused-components
    BRow,
    // eslint-disable-next-line vue/no-unused-components
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    BBadge,
    BAvatar,
    BPagination,
    // eslint-disable-next-line vue/no-unused-components
    BFormGroup,
    // eslint-disable-next-line vue/no-unused-components
    BFormSelect,
    BFormInput,
    vSelect,
    flatPickr
  },
  props: {
    fields: {
      type: Array,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => {},
    },
    totalRows: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
    },
    displayLoading: {
      type: Boolean,
      default: false,
    },
    tableMaxHeight: {
      type: String,
      default: AppConstants.CUSTOM_TABLE_DEFAULT_HEIGHT,
    },
    hasEditButton: Boolean,
    hasDeleteButton: Boolean,
    hasSyncButton: Boolean,
    hasResendButton: Boolean,
    hasOpenTemplateButton: Boolean,
    hasAnswer: Boolean,
    hasUpdateDataButton: Boolean,
    hasExportDataButton: Boolean,
    hasAdvancedFilterButton: Boolean,
    advancedFilters: {
      type: Array,
      default: () => {},
    },
    hasPerPageSelect: {
      type: Boolean,
      default: false,
    },
    // Filtro de texto das colunas busca enquanto digita (debounce de 400ms do vue-good-table) em vez de só no Enter
    filterOnType: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // dd/mm/aaaa: formato esperado pelo PaginationHelper.createDateFilter do backend
      columnFilterDateConfig: {
        enableTime: false,
        dateFormat: 'd/m/Y',
        allowInput: false,
      },
      dateColumnFilters: {},
      numericColumnFilters: {},
      numericFilterWarnings: {},
      phoneMask: {
        phone: true,
        phoneRegionCode: "BR",
      },
      pageOptions: [],
      currentPage: 1,
      currentRowDetail: null,
      searchTerm: '',
      perfectScrollbarSettings: {
        // maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        swipeEasing: true,
        // useBothWheelAxes: true,
        minScrollbarLength: 10,
      },
      rows: [],
      isLoading: false,
      displayAdvancedFilters: false
    };
  },
  computed: {
    // As telas definem trigger: 'enter' nas colunas; sem ele o vue-good-table filtra no input com debounce.
    // O Enter continua filtrando na hora (cancela o debounce)
    tableColumns() {
      if (!this.filterOnType) return this.fields;
      return this.fields.map((column) => {
        if (!column.filterOptions || column.filterOptions.trigger !== 'enter') return column;
        // eslint-disable-next-line no-unused-vars
        const { trigger, ...filterOptions } = column.filterOptions;
        return { ...column, filterOptions };
      });
    },
  },
  created() {
    this.pageOptions = AppConstants.PAGINATOR_DEFAULT_PAGE_SIZE_OPTIONS;
    // Timers do filtro numerico fora do data(): nao precisam ser reativos
    this.numericFilterTimer = null;
    this.numericFilterWarningTimers = {};
  },
  beforeDestroy() {
    clearTimeout(this.numericFilterTimer);
    Object.values(this.numericFilterWarningTimers).forEach(clearTimeout);
  },
  watch: {
    limit(newLimit) {
    this.$emit('limitChanged', newLimit);
  }
    // displayLoading(val) {
    //   console.log('[displayLoading]', val)
    //   this.isLoading = val;
    // }
  },
  methods: {
    isDateFilterColumn(column) {
      return column.type === 'custom_date' && !!column.filterOptions && !!column.filterOptions.enabled;
    },
    getDateFilterValue(column) {
      if (Object.prototype.hasOwnProperty.call(this.dateColumnFilters, column.field)) {
        return this.dateColumnFilters[column.field];
      }
      // Valor vindo da URL só é usado se for dd/mm/aaaa completo; o flatpickr interpretaria "16" como 16/01
      const initialValue = column.filterOptions.filterValue || '';
      return /^\d{2}\/\d{2}\/\d{4}$/.test(initialValue) ? initialValue : '';
    },
    onDateColumnFilter(props, value) {
      if (value === this.getDateFilterValue(props.column)) return;
      this.$set(this.dateColumnFilters, props.column.field, value);
      props.updateFilters(props.column, value);
    },
    isNumericFilterColumn(column) {
      return !!column.filterOptions && !!column.filterOptions.enabled && !!column.filterOptions.numeric;
    },
    getNumericFilterValue(column) {
      if (Object.prototype.hasOwnProperty.call(this.numericColumnFilters, column.field)) {
        return this.numericColumnFilters[column.field];
      }
      return String(column.filterOptions.filterValue || '').replace(/\D/g, '');
    },
    // Mesmo comportamento do filtro padrao do vue-good-table: busca ao digitar com debounce
    // de 400ms (Enter busca na hora) ou, com trigger 'enter', so no Enter
    onNumericColumnFilter(props, event, immediate = false) {
      const input = event.target;
      const value = String(input.value || '').replace(/\D/g, '');
      const field = props.column.field;
      if (input.value !== value) {
        input.value = value;
        this.showNumericFilterWarning(field);
      }

      if (this.numericFilterTimer) clearTimeout(this.numericFilterTimer);
      const apply = () => {
        if (value === this.getNumericFilterValue(props.column)) return;
        this.$set(this.numericColumnFilters, field, value);
        props.updateFilters(props.column, value);
      };
      if (immediate) {
        apply();
        return;
      }
      if (props.column.filterOptions.trigger === 'enter') return;
      this.numericFilterTimer = setTimeout(apply, 400);
    },
    showNumericFilterWarning(field) {
      this.$set(this.numericFilterWarnings, field, true);
      clearTimeout(this.numericFilterWarningTimers[field]);
      this.numericFilterWarningTimers[field] = setTimeout(() => {
        this.$set(this.numericFilterWarnings, field, false);
      }, 2500);
    },
    getTextLimit(limit, text) {
      return formatFieldHelper.limitFieldLength(text, limit);
    },
    onRowClick() {
      this.$refs.menu.open;
    },
    getLabelField(item, rowFields) {
      const index = rowFields.findIndex((r) => r.key == item);
      if (index >= 0) {
        return rowFields[index].label;
      }
      return item;
    },
    getDataArray(rowList, field, fieldType, objectInObjectField) {
      if (!rowList || rowList.length === 0) return '';
      if (field === 'profile') {
        return rowList.map(item => this.getDataObject(item, field, fieldType, objectInObjectField)).join(', ');
      }
      return rowList.map(item => this.getDataObject(item, field, fieldType, objectInObjectField)).join(', ');
    },
    getDataObject(data, field, fieldType, objectInObjectField) {
      if (!data) {
        return '';
      }
      if (field === 'system_prop' && objectInObjectField === 'profile') {
        const systemProp = data[field];
        if (Array.isArray(systemProp) && systemProp.length > 0) {
          return this.getProfileName(systemProp[0].profile);
        }
        return '';
      }
      if (field == 'profile') {
        return this.getProfileName(data[field]);
        // switch (data[field]) {
        //   case AppConstants.CLIENT_PROFILE.FREE:
        //     return AppConstants.CLIENT_PROFILE_OBJ.find(item => item.id == AppConstants.CLIENT_PROFILE.FREE).name;
        //   case AppConstants.CLIENT_PROFILE.DEMO:
        //     return AppConstants.CLIENT_PROFILE_OBJ.find(item => item.id == AppConstants.CLIENT_PROFILE.DEMO).name;
        //   case AppConstants.CLIENT_PROFILE.SUBSCRIBER:
        //     return AppConstants.CLIENT_PROFILE_OBJ.find(item => item.id == AppConstants.CLIENT_PROFILE.SUBSCRIBER).name;
        // }
      }
      if (fieldType) {
        if (fieldType == 'custom_date') {
          return this.getDateFormat(data[field]);
        }
        if (fieldType == 'boolean') {
          return this.getActiveBadgeLabel(data[field]);
        }
      }
      if (objectInObjectField) {
        if (data[field]) {
          return data[field][objectInObjectField];
        }
        return data[field];
      }
      if (field) {
        return data[field];
      }
      if (data.labelPtBr) {
        return data.labelPtBr;
      }
      if (data.namePtBr) {
        return data.namePtBr;
      }
      if (data.name) {
        return data.name;
      }
      return data;
    },
    getProfileName(profileValue) {
      switch (profileValue) {
        case AppConstants.CLIENT_PROFILE.FREE:
          return AppConstants.CLIENT_PROFILE_OBJ.find(item => item.id === AppConstants.CLIENT_PROFILE.FREE).name;
        case AppConstants.CLIENT_PROFILE.DEMO:
          return AppConstants.CLIENT_PROFILE_OBJ.find(item => item.id === AppConstants.CLIENT_PROFILE.DEMO).name;
        case AppConstants.CLIENT_PROFILE.SUBSCRIBER:
          return AppConstants.CLIENT_PROFILE_OBJ.find(item => item.id === AppConstants.CLIENT_PROFILE.SUBSCRIBER).name;
        default:
          return profileValue?.toString() || '';
      }
    },
    getPhoneFormat(phone) {
      return phone;
    },
    getDateFormat(dt) {
      // return convertDatetimeHelper.convertStringToDateTime(dt);
      return formatDate(dt, {
        dateStyle: "short",
        timeStyle: "short",
      });
    },
    onchangeCheckbox(t) {
      console.log(t);
      t.toggleDetails();
    },
    getActiveBadgeLabel(active) {
      return translateFieldHelper.translateBooleanToLocale(active);
    },
    getActiveBadge(active) {
      if (active) {
        return "light-success";
      }
      return "light-danger";
    },
    handleChangePage(page) {
      console.log("page: ", page);
      this.$emit("changePage", page);
    },
    getObjectKeys(object) {
      return Object.keys(object);
    },
    onRowClicked(row) {
      // console.log(row);
      this.$set(row, "_showDetails", !row._showDetails);
      if (this.currentRowDetail) {
        if (this.currentRowDetail.id != row.id) {
          if (this.currentRowDetail._showDetails) {
            this.$set(
              this.currentRowDetail,
              "_showDetails",
              !this.currentRowDetail._showDetails
            );
          }
        }
      }
      this.currentRowDetail = row;
    },
    onEdit(data) {
      console.log("onEdit: ", data);
      this.$emit("onEdit", data);
    },
    onDelete(data) {
      messageDialogHelper.displayConfirmMessage(
        "Deleção",
        "Deseja deletar o registro?",
        () => {
          console.log("onDelete: " + data);
          this.$emit("onDelete", data);
        }
      );
    },
    onResend(data) {
      console.log("onResend: " + data);
      this.$emit("onResend", data);
    },
    openTemplate(data) {
      console.log("openTemplate: " + data);
      this.$emit("openTemplate", data);
    },
    openAnswer(data) {
      console.log("openAnswer: " + data);
      this.$emit("openAnswer", data);
    },
    onSync(data) {
      console.log("onSync: " + data);
      this.$emit("onSync", data);
    },
    onSortChange(params) {
      console.log(`the user ordered:  ${JSON.stringify(params)}`)
      this.$emit("onSortChange", params[0]);
    },
    onColumnFilter(params) {
      // console.log('onColumnFilter params: ', params);
      this.$emit('onColumnFilter', params.columnFilters)
    },
    updateData() {
      console.log("Updating page data");
      this.$emit("updateData");
    },
    exportData() {
      console.log("Export data");
      this.$emit("exportData");
    },
    openAdvancedFilter() {
      this.displayAdvancedFilters = !this.displayAdvancedFilters;
    },
    fetchAdvancedFilter() {
      const data = {};
      for (let index = 0; index < this.advancedFilters.length; index++) {
        // if (this.advancedFilters[index].value) data[this.advancedFilters[index].field] = this.advancedFilters[index].value;
        data[this.advancedFilters[index].field] = this.advancedFilters[index].value;
      }
      this.$emit("fetchAdvancedFilter", data);
    },
    clearAdvancedFilter() {
      for (let index = 0; index < this.advancedFilters.length; index++) {
        this.advancedFilters[index].value = '';
      }
      this.fetchAdvancedFilter();
    }
  },
};
</script>

<style>
.column-filter-date {
  position: relative;
}
.column-filter-date .vgt-input {
  padding-right: 24px;
}
.column-filter-date-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}
.column-filter-numeric {
  position: relative;
}
/* Abaixo do campo, sem empurrar a linha de filtros */
.column-filter-numeric-warning {
  position: absolute;
  left: 0;
  top: 100%;
  z-index: 2;
  white-space: nowrap;
  color: #ea5455;
}
</style>
